import { createSelector } from 'reselect'
import { get } from 'lodash'

import key from './types'
import { initialState } from './reducer'

const selectHistory = state => get(state, key, initialState)

const selectLoading = createSelector(
  selectHistory, state => get(state, 'loading', null)
)

const selectSuccess = createSelector(
  selectHistory, state => get(state, 'list', null)
)

const selectColumns = createSelector(
  selectHistory, state => get(state, 'columns', null)
)

const selectPages = createSelector(
  selectHistory, state => get(state, 'pages', null)
)

const selectTotalItems = createSelector(
  selectHistory, state => get(state, 'totalItems', 0)
)

const selectError = createSelector(
  selectHistory, state => get(state, 'error', null)
)

const selectDataFilters = createSelector(
  selectHistory, state => get(state, 'dataFilters', null)
)

const selectDataFiltersError = createSelector(
  selectHistory, state => get(state, 'dataFiltersError', null)
)

const selectLoadingList = createSelector(
  selectHistory, state => get(state, 'loadingList', null)
)

export default {
  SUCCESS: selectSuccess,
  COLUMNS: selectColumns,
  ERROR: selectError,
  LOADING: selectLoading,
  PAGES: selectPages,
  TOTAL_ITEMS: selectTotalItems,
  FILTER_OBJECT: selectDataFilters,
  ERROR_FILTER_OBJECT: selectDataFiltersError,
  LOADING_LIST: selectLoadingList
}
